'use client';
import { Fragment } from 'react/jsx-runtime';
import { motion } from 'framer-motion';
import { Button } from '@/components/button';
import Image from 'next/image';
import ray03 from '@/public/images/ray03.jpg';
import { SOCIAL_LINKS } from '@/utils/constants';
import Link from 'next/link';

type Props = {
  text?: string | string[];
  className?: string;
};

export default function SectionAbout({ className }: Readonly<Props>) {
  const transition = { duration: 1, ease: [0.25, 0.1, 0.25, 1] };
  const variants = {
    hidden: { filter: 'blur(10px)', transform: 'translateY(20%)', opacity: 0 },
    visible: {
      filter: 'blur(0)',
      transform: 'translateY(0)',
      opacity: 1,
    },
  };

  return (
    <motion.section
      initial="hidden"
      animate="visible"
      transition={{ staggerChildren: 0.04 }}
      className={`relative grid grid-cols-1 gap-x-12 md:grid-cols-12 ${className || ''}`}>
      <div className="md:col-span-7">
        <div className="sticky top-20">
          <motion.h1
            animate={transition}
            variants={variants}
            className="dark:text-copper relative max-w-4xl font-serif text-3xl leading-14 tracking-tight lg:text-5xl">
            About
          </motion.h1>

          <motion.p
            animate={transition}
            variants={variants}
            className="pt-4 text-xl leading-snug font-light lg:text-2xl dark:text-white/60">
            I'm Raymond Lopez. These days, I run the digital backbone for a
            local carbon fiber manufacturer, handling everything from the
            website to finances to shipping logistics. Before that, I cut my
            teeth in the high-velocity world of startups, co-founding EdgeIn as
            head of product and design. We raised $1M and landed a TechCrunch
            feature along the way.
          </motion.p>

          <motion.p
            animate={transition}
            variants={variants}
            className="pt-4 text-xl leading-snug font-light lg:text-2xl dark:text-white/60">
            I'm always up for a conversation about frontend architecture or
            design systems{' '}
            <Link href="/contact" className="underline-grow">
              Let’s chat
            </Link>
          </motion.p>
        </div>
      </div>

      <div className="sm:mt-6 md:col-span-4 md:col-start-9">
        <motion.div animate={transition} variants={variants}>
          <motion.div
            initial={{ rotate: 0 }}
            animate={{
              rotate: [0, 2],
            }}
            transition={{
              delay: 1,
              duration: 0.5,
              ease: [0.25, 0.1, 0.25, 1],
            }}>
            <Image
              src={ray03}
              alt="Raymond Lopez"
              title="Raymond Lopez"
              priority
              className="mt-20 mb-8 aspect-square w-full scale-x-[-1] rounded-lg object-cover object-center md:mt-0 md:size-80"
            />
          </motion.div>
        </motion.div>

        <div className="mt-8 flex flex-wrap items-center gap-4">
          {SOCIAL_LINKS.map((item: any, index: number) => (
            <motion.div
              key={item.label}
              animate={transition}
              variants={variants}>
              <Button href={item.href} key={item.label} className="p-3" size="">
                <item.icon className="size-6" />
              </Button>
            </motion.div>
          ))}
        </div>

        {/* <h3 className="dark:text-ivory mb-4 text-sm font-bold tracking-wider uppercase">
                Development Services
              </h3>

              <ul className="text-dark/60 dark:text-ivory/60 lg:mb-8 lg:text-lg">
                {services.development.map((service: any, index: number) => {
                  return (
                    <li className="leading-10" key={index}>
                      {service}
                    </li>
                  );
                })}
              </ul>

              <h3 className="dark:text-ivory mt-10 mb-4 text-sm font-bold tracking-wider uppercase">
                Design Services
              </h3>
              <ul className="text-dark/60 dark:text-ivory/60 lg:text-lg">
                {services.design.map((service: any, index: number) => {
                  return (
                    <li className="leading-10" key={index}>
                      {service}
                    </li>
                  );
                })}
              </ul> */}
      </div>
    </motion.section>
  );
}
